export function Spinner({ className = '' }: { className?: string }) {
  return <span className={`inline-block size-6 animate-spin rounded-full border-2 border-primary-300 border-t-primary-700 ${className}`} aria-label="Đang tải" />
}
